{
  "version": 1,
  "asset_id": "b8ada2ef-c51c-4d8a-bfcd-2d9be1a9c4d3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b8ada2ef-c51c-4d8a-bfcd-2d9be1a9c4d3/gastric-bypass-es-v2-1536.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b8ada2ef-c51c-4d8a-bfcd-2d9be1a9c4d3/gastric-bypass-es-v2-1536.jpg",
  "original_filename": "gastric-bypass-es-v2-1536.jpg",
  "size": 169546,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:00:39Z"
}
